var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { $ } from 'hanako-ts/dist-legacy/Framework';
import { Component } from 'hanako-ts/dist-legacy/Component';
export class FunnyCursor extends Component {
    constructor(isDebugEnabled = false) {
        super('FunnyCursor', false);
    }
    init() {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield _super.init.call(this);
            if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
                FunnyCursor.cursorElement = $.parseHTML('<div class="funny-cursor d-none"><div class="funny-cursor-image d-none"></div></div>');
                $('body').append(FunnyCursor.cursorElement);
                $('html').on('mouseleave', () => {
                    FunnyCursor.cursorElement.addClass('d-none');
                });
                $('html').on('mouseenter', () => {
                    FunnyCursor.cursorElement.removeClass('d-none');
                });
                $(window).on('mousemove', FunnyCursor.mouseMoveHandler);
                FunnyCursor.update();
                const lastRawPosition = sessionStorage.getItem('last-cursor-position');
                if (lastRawPosition) {
                    try {
                        FunnyCursor.cursorPosition = FunnyCursor.mousePosition = JSON.parse(lastRawPosition);
                        FunnyCursor.setDotPosition(FunnyCursor.cursorPosition);
                    }
                    catch (_a) { }
                }
            }
            this.success();
        });
    }
    static setDotPosition(position) {
        FunnyCursor.cursorElement.css({
            left: position.x,
            top: position.y,
        });
        FunnyCursor.cursorElement.removeClass('d-none');
    }
    static update() {
        FunnyCursor.cursorPosition = FunnyCursor.inertiaTo();
        FunnyCursor.setDotPosition(FunnyCursor.cursorPosition);
        requestAnimationFrame(FunnyCursor.update);
    }
    static mouseMoveHandler(event) {
        FunnyCursor.mousePosition = {
            x: event.clientX,
            y: event.clientY
        };
        if (FunnyCursor.isFirstRun) {
            FunnyCursor.cursorPosition = FunnyCursor.mousePosition;
            FunnyCursor.isFirstRun = false;
        }
        sessionStorage.setItem('last-cursor-position', JSON.stringify(FunnyCursor.mousePosition));
        const target = event.target;
        if (target.tagName == 'CANVAS' || $(target).hasClass('funny-cursor-disabled')) {
            $('body').addClass('funny-cursor-disabled');
        }
        else {
            $('body').removeClass('funny-cursor-disabled');
        }
        let isInsideAcfSwitch = false;
        try {
            isInsideAcfSwitch = $(target).parents('.acf-switch').length > 0;
        }
        catch (_a) { }
        let isInsideLink = false;
        try {
            isInsideLink = $(target).parents('a').length > 0;
        }
        catch (_b) { }
        let isBookLink = false;
        try {
            isBookLink = $(target).hasClass('book-slice') || $(target).parents('.book-slice').length > 0 || $(target).hasClass('book-cover') || $(target).parents('.book-cover').length > 0;
        }
        catch (_c) { }
        if (['A', 'INPUT', 'BUTTON', 'SELECT', 'TEXTAREA'].indexOf(target.tagName) != -1 || isInsideAcfSwitch || isInsideLink || isBookLink) {
            if (['text', 'email', 'number', 'password'].indexOf($(target).attr('type')) != -1) {
                FunnyCursor.cursorElement.addClass('funny-cursor-text');
            }
            else {
                FunnyCursor.cursorElement.addClass('funny-cursor-small');
            }
        }
        else {
            FunnyCursor.cursorElement.removeClass('funny-cursor-small funny-cursor-text');
        }
        const bookLinkTarget = $(target).parents('.book-link').length > 0 ? $(target).parents('.book-link') : $(target);
        if (bookLinkTarget.hasClass('book-link')) {
            FunnyCursor.cursorElement.find('.funny-cursor-image').removeClass('d-none').css('background-image', 'url(' + bookLinkTarget.css('--cursor-image') + ')');
        }
        else {
            FunnyCursor.cursorElement.find('.funny-cursor-image').addClass('d-none');
        }
        if ($(target).hasClass('btn-primary')) {
            FunnyCursor.cursorElement.addClass('funny-cursor-inverted');
        }
        else {
            FunnyCursor.cursorElement.removeClass('funny-cursor-inverted');
        }
        FunnyCursor.cursorElement.removeClass('d-none');
    }
    static inertiaTo() {
        if (FunnyCursor.inertia == 1)
            return FunnyCursor.mousePosition;
        const distanceToGo = {
            x: FunnyCursor.mousePosition.x - FunnyCursor.cursorPosition.x,
            y: FunnyCursor.mousePosition.y - FunnyCursor.cursorPosition.y
        };
        const delta = {
            x: FunnyCursor.cursorPosition.x + distanceToGo.x * FunnyCursor.inertia,
            y: FunnyCursor.cursorPosition.y + distanceToGo.y * FunnyCursor.inertia,
        };
        if (Math.abs(distanceToGo.x) < 0.01)
            delta.x = FunnyCursor.mousePosition.x;
        if (Math.abs(distanceToGo.y) < 0.01)
            delta.y = FunnyCursor.mousePosition.y;
        return delta;
    }
}
FunnyCursor.isFirstRun = true;
FunnyCursor.cursorPosition = { x: 0, y: 0 };
FunnyCursor.mousePosition = { x: 0, y: 0 };
FunnyCursor.inertia = 1;
